import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconVisibility.tsx
const OutlinedFilledVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Z" })
});
const OutlinedVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Zm0-323Zm-.08 240q120.45 0 221.27-65.5Q802-391 855-500q-53-109-153.73-174.5Q600.53-740 480.08-740t-221.27 65.5Q158-609 104-500q54 109 154.73 174.5Q359.47-260 479.92-260Z" })
});
const RoundedFilledVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-140 0-254.95-77.18Q110.1-331.35 42-454q-6-10.92-9-22.66-3-11.75-3-23.32t3-23.26q3-11.69 9-22.76 68.1-122.65 183.05-199.82Q340-823 480-823t254.95 77.18Q849.9-668.65 918-546q6 10.92 9 22.66 3 11.75 3 23.32t-3 23.26q-3 11.69-9 22.76-68.1 122.65-183.05 199.82Q620-177 480-177Z" })
});
const RoundedVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-140 0-254.95-77.18Q110.1-331.35 42-454q-6-10.92-9-22.66-3-11.75-3-23.32t3-23.26q3-11.69 9-22.76 68.1-122.65 183.05-199.82Q340-823 480-823t254.95 77.18Q849.9-668.65 918-546q6 10.92 9 22.66 3 11.75 3 23.32t-3 23.26q-3 11.69-9 22.76-68.1 122.65-183.05 199.82Q620-177 480-177Zm0-323Zm-.08 240Q601-260 701.5-325.5 802-391 855-500q-53-109-153.42-174.5Q601.16-740 480.08-740T258.5-674.5Q158-609 104-500q54 109 154.42 174.5Q358.84-260 479.92-260Z" })
});
const SharpFilledVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Z" })
});
const SharpVisibility = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5q0-70.88-49.62-120.38T479.88-670Q409-670 359.5-620.38T310-499.88q0 70.88 49.62 120.38t120.5 49.5Zm-.12-74q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 227q-154 0-278-90T17-500q61-143 185-233t278-90q154 0 278 90t185 233q-61 143-185 233t-278 90Zm0-323Zm-.08 240q120.45 0 221.27-65.5Q802-391 855-500q-53-109-153.73-174.5Q600.53-740 480.08-740t-221.27 65.5Q158-609 104-500q54 109 154.73 174.5Q359.47-260 479.92-260Z" })
});
const componentMap = {
	outlined: OutlinedVisibility,
	"outlined-fill": OutlinedFilledVisibility,
	rounded: RoundedVisibility,
	"rounded-fill": RoundedFilledVisibility,
	sharp: SharpVisibility,
	"sharp-fill": SharpFilledVisibility
};
const IconVisibility = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconVisibility };